/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S10_P2_PathInputs */

const tr_iade_iptal_s10_p2_path = /** @type {(inputs: Iade_Iptal_S10_P2_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kvkk@emonse.com`)
};

const en_iade_iptal_s10_p2_path = /** @type {(inputs: Iade_Iptal_S10_P2_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kvkk@emonse.com`)
};

const de_iade_iptal_s10_p2_path = /** @type {(inputs: Iade_Iptal_S10_P2_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kvkk@emonse.com`)
};

const ru_iade_iptal_s10_p2_path = /** @type {(inputs: Iade_Iptal_S10_P2_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kvkk@emonse.com`)
};

/**
* | output |
* | --- |
* | "kvkk@emonse.com" |
*
* @param {Iade_Iptal_S10_P2_PathInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s10_p2_path = /** @type {((inputs?: Iade_Iptal_S10_P2_PathInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S10_P2_PathInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s10_p2_path(inputs)
	if (locale === "de") return de_iade_iptal_s10_p2_path(inputs)
	if (locale === "ru") return ru_iade_iptal_s10_p2_path(inputs)
	return tr_iade_iptal_s10_p2_path(inputs)
});